/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/tailwindcss-intersect/dist/index.esm.js":
/*!**************************************************************!*\
  !*** ./node_modules/tailwindcss-intersect/dist/index.esm.js ***!
  \**************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Observer": () => (/* binding */ observer_default),
/* harmony export */   "default": () => (/* binding */ src_default)
/* harmony export */ });
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/tailwindcss/lib/util/createPlugin.js
var require_createPlugin = __commonJS({
  "node_modules/tailwindcss/lib/util/createPlugin.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "default", {
      enumerable: true,
      get: function() {
        return _default;
      }
    });
    function createPlugin(plugin2, config) {
      return {
        handler: plugin2,
        config
      };
    }
    createPlugin.withOptions = function(pluginFunction, configFunction = () => ({})) {
      const optionsFunction = function(options) {
        return {
          __options: options,
          handler: pluginFunction(options),
          config: configFunction(options)
        };
      };
      optionsFunction.__isOptionsFunction = true;
      optionsFunction.__pluginFunction = pluginFunction;
      optionsFunction.__configFunction = configFunction;
      return optionsFunction;
    };
    var _default = createPlugin;
  }
});

// node_modules/tailwindcss/lib/public/create-plugin.js
var require_create_plugin = __commonJS({
  "node_modules/tailwindcss/lib/public/create-plugin.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "default", {
      enumerable: true,
      get: function() {
        return _default;
      }
    });
    var _createPlugin = /* @__PURE__ */ _interop_require_default(require_createPlugin());
    function _interop_require_default(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var _default = _createPlugin.default;
  }
});

// node_modules/tailwindcss/plugin.js
var require_plugin = __commonJS({
  "node_modules/tailwindcss/plugin.js"(exports, module) {
    var createPlugin = require_create_plugin();
    module.exports = (createPlugin.__esModule ? createPlugin : { default: createPlugin }).default;
  }
});

// src/plugin/index.js
var import_plugin = __toESM(require_plugin(), 1);
var plugin_default = (0, import_plugin.default)(
  ({ addVariant }) => {
    addVariant("intersect", "&:not([no-intersect])");
  }
);

// src/observer/index.js
var Observer = {
  start() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.observe());
      return;
    }
    this.observe();
  },
  observe() {
    const selectors = [
      '[class*=" intersect:"]',
      '[class*=":intersect:"]',
      '[class^="intersect:"]',
      '[class="intersect"]',
      '[class*=" intersect "]',
      '[class^="intersect "]',
      '[class$=" intersect"]'
    ];
    document.querySelectorAll(selectors.join(",")).forEach((element) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            element.setAttribute("no-intersect", "");
            return;
          }
          element.removeAttribute("no-intersect");
          element.classList.contains("intersect-once") && observer.disconnect();
        });
      }, {
        threshold: this.getThreshold(element)
      });
      observer.observe(element);
    });
  },
  getThreshold(element) {
    if (element.classList.contains("intersect-full")) {
      return 0.99;
    }
    if (element.classList.contains("intersect-half")) {
      return 0.5;
    }
    return 0;
  }
};
var observer_default = Observer;

// src/index.js
var src_default = plugin_default;



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!*********************************!*\
  !*** ./src/js/layout/global.js ***!
  \*********************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tailwindcss_intersect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tailwindcss-intersect */ "./node_modules/tailwindcss-intersect/dist/index.esm.js");

tailwindcss_intersect__WEBPACK_IMPORTED_MODULE_0__.Observer.start();
/*
 * Shopify Common JS
 *
 */

if (typeof window.Axial == 'undefined') {
  window.Axial = {};
}

Axial.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Axial.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];

    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      selector.dispatchEvent(new Event('change', {
        bubbles: true
      }));
      return i;
    }
  }
};

Axial.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Axial.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Axial.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Axial.addListener(this.countryEl, 'change', Axial.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Axial.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Axial.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');

    if (value && this.provinceEl.options.length > 0) {
      Axial.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);

    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Axial.toggleOverlay = function (overlayClass) {
  var $pageContainer = document.querySelector('.page-container');

  if (!$pageContainer) {
    return;
  }

  if (!$pageContainer.classList.contains(overlayClass)) {
    Axial.showOverlay(overlayClass);
  } else {
    Axial.hideOverlay(overlayClass);
  }
};

Axial.showOverlay = function (overlayClass) {
  var $pageContainer = document.querySelector('.page-container');

  if (!$pageContainer) {
    return;
  }

  $pageContainer.classList.add(overlayClass);
  $pageContainer.addEventListener('click', e => {
    if (e.target.id === $pageContainer.id) {
      let mobileFilters = document.querySelector('.show-filters-menu-action');
      const clickEvent = new Event('click');
      mobileFilters.dispatchEvent(clickEvent);
    }
  });
};

Axial.hideOverlay = function (overlayClass) {
  var $pageContainer = document.querySelector('.page-container');

  if (!$pageContainer) {
    return;
  }

  $pageContainer.classList.remove(overlayClass);
};

Axial.handleize = function (str) {
  str = str.toLowerCase();
  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"]; // For the old browsers

  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replaceAll(toReplace[i], "");
  }

  str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) == "-") {
    str = str.replace(/-*$/, "");
  }

  if (str.charAt(0) == "-") {
    str = str.replace(/\A-+/, "");
  }

  return str;
};

Axial.getBrowserLanguage = function () {
  var lang = window.navigator.userLanguage || window.navigator.language;
  return lang.split('-')[0];
};

Axial.getSiteLanguage = function () {
  return document.documentElement.lang;
};

Object.defineProperty(String.prototype, 'capitalize', {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});
customElements.define('visual-input', class VisualInput extends HTMLElement {
  constructor() {
    super();
    var self = this;
    var input = this.querySelector('input');
    input.addEventListener('focus', function (e) {
      self.classList.add('is-focused');
    });
    input.addEventListener('blur', function (e) {
      self.classList.remove('is-focused');

      if (input.value) {
        self.classList.add('is-filled');
      } else {
        self.classList.remove('is-filled');
      }
    });
    input.addEventListener('input', function (e) {
      if (!self.classList.contains('is-focused')) {
        self.classList.add('is-filled');
      }
    });

    if (input.value !== '') {
      this.classList.add('is-filled');
    }
  }

});
customElements.define('visual-select', class VisualSelect extends HTMLElement {
  constructor() {
    super();
    var self = this;
    var select = this.querySelector('select');
    select.addEventListener('change', function (e) {
      self.classList.remove('is-focused');

      if (select.value) {
        self.classList.add('is-filled');
      } else {
        self.classList.remove('is-filled');
      }
    });

    if (select.value !== '') {
      this.classList.add('is-filled');
    }
  }

});
customElements.define('visual-textarea', class VisualTextarea extends HTMLElement {
  constructor() {
    super();
    var self = this;
    var input = this.querySelector('textarea');
    input.addEventListener('focus', function (e) {
      self.classList.add('is-focused');
    });
    input.addEventListener('input', function (e) {
      if (!self.classList.contains('is-focused')) {
        self.classList.add('is-filled');
      }
    });
    input.addEventListener('blur', function (e) {
      self.classList.remove('is-focused');

      if (input.value) {
        self.classList.add('is-filled');
      } else {
        self.classList.remove('is-filled');
      }
    });
  }

});

if (customElements.get('blog-posts') === undefined) {
  customElements.define('blog-posts', class BlogPosts extends HTMLElement {
    constructor() {
      super();
      this.getPosts();
    }

    async fetchBlogPostsByTag(tag) {
      if (tag === undefined || tag === '') {
        return false;
      }

      const articlesData = await fetch(`/api/${Axial.storefront.api_version}/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': Axial.storefront.api_key
        },
        body: JSON.stringify({
          query: `
              query GetArticlesByTags {
                articles(first: 10, query: "tag:${tag}") {
                  edges {
                    node {
                      title
                      onlineStoreUrl
                      image {
                        url
                        altText
                      }
                      publishedAt
                      tags
                      blog {
                        handle
                      }
                    }
                  }
                }
              }
          `
        })
      }).catch(e => console.log('error', e));
      return articlesData.json();
    }

    async getPosts() {
      var _posts$data, _posts$data$articles;

      const posts = await this.fetchBlogPostsByTag(this.dataset.tag);
      const postsData = posts === null || posts === void 0 ? void 0 : (_posts$data = posts.data) === null || _posts$data === void 0 ? void 0 : (_posts$data$articles = _posts$data.articles) === null || _posts$data$articles === void 0 ? void 0 : _posts$data$articles.edges;

      if (postsData) {
        this.buildLayout(postsData);
      }
    } // It's building the layout of the page.


    buildLayout(data) {
      const self = this;
      const articleListing = this.querySelector('.article-listing');
      const articleTemplate = this.querySelector('template[data-id="article"]');
      articleListing.innerHTML = '';
      data.forEach(itemData => {
        const {
          node
        } = itemData;
        let content = articleTemplate.innerHTML.trim();
        let data = {
          "articleUrl": node.onlineStoreUrl,
          "articleImageUrl": node.image.url,
          "articleImageAlt": node.image.altText,
          "articleTitle": node.title,
          "articleDate": node.publishedAt
        };
        let tags = '';
        node.tags.forEach(tag => {
          tags += `<a href="${window.Axial.routes.root}blogs/${node.blog.handle}/tagged/${Axial.handleize(tag)}" class="bg-black text-white px-3 py-1 rounded">${tag}</a>`;
        });
        data['articleTags'] = tags;
        content = content.replace(/{([^{}]+)}/g, function (keyExpr, key) {
          return data[key] || "";
        });
        let articleElement = self.htmlToElement(content);
        articleListing.appendChild(articleElement);
      });
    }

    htmlToElement(html) {
      const template = document.createElement('template');
      html = html.trim();
      template.innerHTML = html;
      return template.content.firstChild;
    }

  });
}

if (customElements.get('search-autocomplete') === undefined) {
  customElements.define('search-autocomplete', class SearchAutocomplete extends HTMLElement {
    constructor() {
      super();
      this.searchInput = this.querySelector('input[name="q"]');
      this.searchListing = this.querySelector('.listing');
      this.loadingIcon = this.querySelector('.loading-icon');
      this.searchIcon = this.querySelector('button[type="submit"]');
      this.internalTimer = 0;
      this.initListeners();
    }

    initListeners() {
      const self = this;
      this.searchInput.addEventListener('input', function (e) {
        self.searchIcon.classList.add('hidden');
        self.loadingIcon.classList.remove('hidden');
        clearTimeout(self.internalTimer);
        self.internalTimer = setTimeout(() => {
          self.search(self.searchInput.value, 'article', 'title,author,tag');
        }, 400);
      });
      this.searchInput.addEventListener('focus', function (e) {
        if (self.searchInput.value.trim() !== '') {
          self.searchIcon.classList.add('hidden');
          self.loadingIcon.classList.remove('hidden');
          clearTimeout(self.internalTimer);
          self.internalTimer = setTimeout(() => {
            self.search(self.searchInput.value, 'article', 'title,author,tag');
          }, 400);
        }
      });
    }

    search(term, type, fields) {
      const self = this;

      if (term.trim() === '') {
        self.searchListing.innerHTML = '';
        self.searchIcon.classList.remove('hidden');
        self.loadingIcon.classList.add('hidden');
        return;
      }

      fetch(window.Axial.routes.root + `search/suggest.json?resources[type]=${type}&q=${term}&resources[options][fields]=${fields}`).then(response => response.json()).then(articles => {
        var _articles$resources, _articles$resources$r;

        const articlesData = articles === null || articles === void 0 ? void 0 : (_articles$resources = articles.resources) === null || _articles$resources === void 0 ? void 0 : (_articles$resources$r = _articles$resources.results) === null || _articles$resources$r === void 0 ? void 0 : _articles$resources$r.articles;

        if (articlesData && articlesData.length > 0) {
          let listingContent = '';
          articlesData.forEach(article => {
            listingContent += `<a href="${article.url}" class="block px-3 py-4 border-b border-gray-100 last:border-0 hover:bg-gray-200">${article.title}</a>`;
          });
          self.searchListing.innerHTML = listingContent;
        } else {
          self.searchListing.innerHTML = '<div class="block px-3 py-4 border-b border-gray-100 last:border-0 hover:bg-gray-200">No result found.</div>';
        }

        self.searchIcon.classList.remove('hidden');
        self.loadingIcon.classList.add('hidden');
      });
    }

  });
}
})();

/******/ })()
;